
export const getPlanningMetod = (op) => {
    switch (op) {
        case 1:
            return "PÍLDORA ANTICONCEPTIVA";
        case 2:
            return "SISTEMA INTRAUTERINO - SIU";
        case 3:
            return "CONDÓN MASCULINO";
        case 4:
            return "PARCHE ANTICONCEPTIVO";
        case 5:
            return "ANILLO ANTICONCEPTIVO";
        case 6:
            return "IMPLANTE ANTICONCEPTIVO";
        case 7:
            return "INYECCIÓN ANTICONCEPTIVA";
        case 8:
            return "DISPOSITIVO INTRAUTERINO - DIU";
        case 9:
            return "CONDÓN FEMENINO";
        case 10:
            return "DIAFRAGMA";
        case 11:
            return "CAPUCHÓN CERVICAL";
        case 12:
            return "ESPONJA";
        case 13:
            return "ESPERMICIDA";
        case 14:
            return "ESTERILIZACIÓN";
        case 15:
            return "PASTILLA DE EMERGENCIA";
        case 16:
            return "ABSTINENCIA SEXUAL";
        case 17:
            return "NINGUNA";
    }
}